import Vue from 'vue'
const TOKEN = 'token'
const USER_INFO = 'loginData'

export function setToken (data) {
  Vue.cookie.set(TOKEN, data)
}

export function setUserInfo (data) {
  localStorage.setItem(USER_INFO, JSON.stringify(data))
}

// 获取用户信息
export function getUserInfo () {
  try {
    return JSON.parse(localStorage.getItem(USER_INFO) || 'null') || {}
  } catch (e) {
    return {}
  }
}

// 获取token
export function getToken () {
  const info = getUserInfo()
  return info.access_token || ''
}
